$(function () {
    /*$('.nav-tabs a').click(function (e) {
        $(this).tab('show');
        var scrollmem = $('body').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });*/

    $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
        $($(e.target).attr('href') + ' .highcharts-container').each(function(){
            var index = $(this).parent().get(0).dataset.highchartsChart,
                chart = Highcharts.charts[index];
                chart.reflow();
        });

        // Automatically redraw AMCharts
        $($(e.target).attr('href')).trigger('amcharts-redraw');
    });

    // Automatically draw AMCharts
    $('a[data-toggle="tab"].active').each(function () {
        $($(this).attr('href')).trigger('amcharts-redraw');
    })

    // Automatically open a tab
    var hash = window.location.hash;
    hash && $('ul.nav a[href="' + hash + '"][data-toggle=tab]').tab('show');

    // Implement methods to handle .nav-tab links that are hidden on mobile.
    // On mobile, a link with a[data-toggle=tab] is put inside the .tab-content right above the
    // .tab-pane it relates to. The Bootstrap implementation of tabs does not support this and
    // uses static selectors that require the links to open the tabs to be inside a list.
    $(document)
        /*.on('hide.bs.tab', function (e) {
            // Do nothing
            console.log('hide.bs.tab', e);
        })*/
        .on('hidden.bs.tab', function (e) {
            //console.log('hidden.bs.tab', e);
            const $tabPanel = $('.tab-pane' + $(e.target).attr('href'));
            $tabPanel.removeClass('active show');
        })
        .on('show.bs.tab', function (e) {
            //console.log('show.bs.tab', e);
            const $clickTarget = $(e.target);
            if ($clickTarget.closest('.tab-content').length) {
                // A .tab-content > a[data-toggle="tab] is being clicked
                const $tabContent = $clickTarget.closest('.tab-content');
                const $normalTarget = $('.nav-tabs .nav-link[data-toggle=tab][href="' + $clickTarget.attr('href') + '"]');
                const $navTabsContainer = $normalTarget.closest('.nav-tabs');
                const $targetTabPane = $tabContent.find('> ' + $clickTarget.attr('href'));
                $navTabsContainer.find('a[data-toggle=tab]').not($normalTarget).removeClass('active');
                const hideEvent = $.Event('hide.bs.tab', {
                    relatedTarget: $normalTarget.get(0)
                });
                const $previous = $tabContent.find('> a[data-toggle=tab].active').not($clickTarget).removeClass('active').trigger(hideEvent);
                $normalTarget.addClass('active');
                $tabContent.find('> .tab-pane.active').not($targetTabPane).removeClass('active show');
                $targetTabPane.addClass('active');

                if (!hideEvent.isDefaultPrevented()) {
                    const hiddenEvent = $.Event('hidden.bs.tab', {
                        relatedTarget: $clickTarget.get(0)
                    });
                    $previous.trigger(hiddenEvent);
                }
            }
        })
        .on('shown.bs.tab', function (e) {
            //console.log('shown.bs.tab', e);
            const $clickTarget = $(e.target);
            $clickTarget.addClass('active');

            if ($clickTarget.closest('.tab-content').length) {
                // A .tab-content > a[data-toggle="tab] is being clicked
                const $tabContent = $clickTarget.closest('.tab-content');
                const $targetTabPane = $tabContent.find('> ' + $clickTarget.attr('href'));
                $targetTabPane.addClass('show');
            }
        });
});